import styled from 'styled-components';
import { device } from "../../../themes/Breakpoints";


export const PlayerCard = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0px;
	padding-left: 20px;
	position: relative;
	flex-wrap: nowrap;
	gap: 25px;
	border-radius: 4px 4px 0px 0px;
	border-top: 1px solid #989ea4;
	border-right: 1px solid #989ea4;
	border-left: 1px solid #989ea4;
	/* background: #fff; */
	&:last-child {
		border-bottom: 1px solid #989ea4;
	}
  @media ${device.laptop} {
    gap: 12px;
  }
   @media ${device.tabletL}{
     gap: 8px;
     padding-left: 8px;
   }
  @media ${device.tablet}{
    gap: 8px;
    padding-left: 8px;
  }
  @media only screen and (max-width: 767px) {
    gap: 8px;
    padding-left: 8px;
    flex-wrap: wrap;
    justify-content: space-between
  }
`;

export const PlayerInfo = styled.div`
	flex: 1;
	padding: 8px;
  &.position {
    max-width: 45px;
    min-width: 45px;
    display: flex;
    justify-content: center;
    text-align: center;
  }
	&.playerName {
      max-width:250px;
      width: 100%;
      min-width: 200px;
      white-space: pre-wrap;
      //word-wrap: break-word;
	}
	&.college {
      min-width:140px ;
      white-space: pre-wrap;
      //word-wrap: break-word;
	}
  &.playerIndex {
    max-width: 40px;
    min-width: 40px;
    width: 100%;
  } 
  &.rank{
    max-width: 45px;
    min-width: 45px;
    text-align: center;
  }
  @media ${device.laptopM} {
    &.playerName {
      min-width:160px;
    }
    &.college {
      min-width:100px ;
    }
  }
  @media ${device.laptop} {
    &.playerName {
      min-width:100px;
    }
    &.college {
       min-width:100px;
       width: 100%;
    }
    &.playerIndex {
      max-width: 30px;
      min-width: 30px;
    }
    &.rank{
      max-width: 35px;
      min-width:  35px;
    }
  }
  @media ${device.tabletL}{
    &.playerName {
      min-width:100px;
    }
    &.college {
      min-width:100px;
      width: 100%;
    }
    &.playerIndex {
      max-width: 30px;
      min-width: 30px;
    }
    &.rank{
      max-width: 35px;
      min-width:  35px;
    }
  }
  @media ${device.tabletL}{
    &.playerName {
      min-width:100px;
    }
    &.college {
      min-width:100px;
      width: 100%;
    }
    &.playerIndex {
      max-width: 30px;
      min-width: 30px;
    }
    &.rank{
      max-width: 35px;
      min-width:  35px;
    }
  }
  @media ${device.mobileL}{
    &.playerName {
      min-width:150px;
    }
    &.college {
      min-width:120px;
      width: 100%;
    }
    &.playerIndex {
      max-width: 30px;
      min-width: 30px;
    }
    &.rank{
      max-width: 35px;
      min-width:  35px;
    }
    &.position{
      max-width: 60px;
      min-width: 60px;
    }
  }
  @media ${device.mobileM}{
    &.playerName {
      min-width:150px;
    }
    &.college {
      min-width:120px;
      width: 100%;
    }
    &.playerIndex {
      max-width: 30px;
      min-width: 30px;
    }
    &.rank{
      max-width: 35px;
      min-width:  35px;
    }
    &.position{
      max-width: 60px;
      min-width: 60px;
    }
  }
  }
   @media ${device.mobileS}{
     &.playerName {
       min-width:100px;
     }
     &.college {
       min-width:80px;
       width: 100%;
     }
     &.position{
       max-width: 40px;
       min-width: 40px;
     }
   }
`;

export const PlayerActions = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 105px;
	max-width: 140px;
	width: 100%;
  @media ${device.laptop} {
    max-width: 100px;
  }
  @media only screen and (max-width: 767px) {
    height: 65px;
    max-width: 100px;
  }
  @media ${device.mobileM}{
    height: 50px;
    max-width: 100px;
  }
  @media ${device.mobileM}{
    height: 50px;
    max-width: 100px;
  }
`;

export const PlayerName = styled.span`
	font-family: 'Saira Semi Condensed', sans-serif;
	color: #00438b;
	font-size: 24px;
	font-style: normal;
	font-weight: 500;
	line-height: 32px;
  @media ${device.laptopM} {
    font-size: 22px;
    text-align: center;
  }
  @media ${device.laptop} {
    font-size: 20px;
    text-align: center;
  }
  @media ${device.tabletL}{
    font-size: 18px;
    text-align: center;
  }
  @media ${device.tablet}{
    font-size: 20px;
    text-align: center;
  }
  @media only screen and (max-width: 767px) {
    font-size:20px;
    text-align: center;
  }
`;

export const PlayerPosition = styled.span`
	color: #000;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;
`;

export const PlayerRank = styled.span`
	color: #000;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px;
  @media ${device.tabletL} {
    font-size: 18px;
  }
  @media ${device.tablet}{
    font-size: 20px;
  }
  @media only screen and (max-width: 767px) {
    font-size:18px;
  }
`;

export const PLayerIndex = styled.div`
	color: #989ea4;
	font-size: 24px;
	font-style: normal;
	font-weight: 600;
	line-height: 32px;
  @media ${device.laptopM} {
    font-size: 22px;
  }
  @media ${device.laptop} {
    font-size: 22px;
  }
  @media ${device.tabletL}{
    font-size: 20px;
  }
  @media ${device.tablet}{
    font-size: 20px;
  }
  @media only screen and (max-width: 767px) {
    font-size:20px;
  }
`;

export const PlayerCollege = styled.span`
	color: #000;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px;
  @media ${device.tabletL} {
    font-size: 18px;
  }
  @media ${device.tablet}{
    font-size: 20px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 18px;
  }
`;

export const ActionButton = styled.button`
	cursor: pointer;
	background: none;
	height: 100%;
	width: 50%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 8px;
	font-weight: 500;
	border: none;
    background: ${({ isAddedGrade }) => (isAddedGrade ? '#D9F1CC' : 'none')};
	&:hover {
		background: rgba(0, 0, 0, 0.1);
	}

	&.delete {
		cursor: pointer;
		color: #e74c3c;
		background: rgba(231, 76, 60, 0.2);
	}

	&.edit {
		color: #022142;
		background: rgba(2, 33, 66, 0.2);
		border-radius: 0 6px 6px 0;
	}
	&.save {
		color: green;
		background: rgba(2, 66, 12, 0.2);
		border-radius: 0 6px 6px 0;
	}
  @media ${device.laptop} {
    padding: 6px;
  }
  @media ${device.tabletL} {
    padding: 6px;
  }
  @media ${device.tablet} {
    padding: 6px;
  }
  @media only screen and (max-width: 767px) {
    padding: 6px;
  }
`;

export const ActionText = styled.span`
	font-family: 'Saira Semi Condensed', sans-serif;
	font-size: 16px;
	color: inherit;
`;

export const Label = styled.div`
	font-family: 'Saira Semi Condensed', sans-serif;
	font-size: 16px;
	color: #46484a;
	margin-bottom: 4px;
`;

export const SelectCount = styled.div`
	position: absolute;
	top: -16px;
	right: -15px;
	width: 30px;
	height: 30px;
	padding: 5px;
	background-color: rgb(0, 67, 139);
	color: rgb(255, 255, 255);
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
`;
